/* tslint:disable:jsx-no-lambda */
import { Button, Checkbox, ComboBox, TextInput } from '@abb/common-ux';
import * as React from 'react';
import { Option } from 'react-select';
import { OptionValues } from '../../../node_modules/@types/react-select';
import { IUserFilterValue } from './models';

export interface IUserFilterProps {
  filter: IUserFilterValue;
  onFilterApply: (filter: IUserFilterValue) => void;
  onClear: () => void;
}

interface IUserFilterState {
  filter: IUserFilterValue;
  countries: Array<Option<OptionValues>>;
}

export class UserFilter extends React.Component<IUserFilterProps, IUserFilterState> {
  constructor(props: any) {
    super(props);

    this.state = {
      filter: props.filter,
      countries: require('./Country.json')
    };
  }

  componentWillReceiveProps(nextProps: IUserFilterProps) {
    this.setState({ filter: nextProps.filter });
  }

  render() {
    const adminOptions = [{ label: 'Admin', value: true }, { label: 'Non-Admin', value: false }];
    const scopeValues = this.state.countries.map((value: any) => {
      const opt = { label: value.countryID, value: value.countryID };
      return opt;
    });

    return (
      <div className='panel panel-default'>
        <div className='panel-body'>
          <form id='pbFilterForm' onSubmit={this.handleApply}>
            <fieldset>
              <legend>FILTER USERS</legend>

              <div className='row'>
                <div className='col-lg-12'>
                  <TextInput
                    name='email'
                    labelText='Email Address'
                    isRequired={false}
                    inputSize='small'
                    placeholder='Email'
                    value={this.state.filter ? this.state.filter.email : ''}
                    onChange={this.handleTextInputChange} />
                </div>
              </div>

              <div className='row'>
                <div className='col-lg-12'>
                  <ComboBox
                    placeholder='Select One'
                    labelText='Admin'
                    options={adminOptions}
                    value={this.state.filter.isAdmin}
                    onChange={this.handleAdminChange}
                    searchable={false}
                    size='small' />
                </div>
              </div>

              <div className='row'>
                <div className='col-lg-12'>
                  <ComboBox
                    placeholder='Select One'
                    labelText='Scopes'
                    options={scopeValues}
                    value={this.state.filter.scopes}
                    onChange={this.handleScopeChange}
                    searchable={false}
                    multiSelect={true}
                    disabled={this.state.filter.allScopes}
                    size='small' />
                </div>
              </div>

              <div className='row'>
              <div className='col-lg-12'>
                <Checkbox
                  id='allScopesCheck'
                  label='Scoped by all countries'
                  checked={this.state.filter.allScopes}
                  onChange={this.handleCheckbox}
                />
              </div>
            </div>

              <div className='row'>
                <div className='col-lg-6' />
                <div className='col-lg-6 form-group text-right'>
                  <Button buttonType='discrete' buttonSize='default' onClick={this.props.onClear} >Clear</Button>{' '}
                  <Button buttonType='primary' buttonSize='default'>Apply</Button>
                </div>
              </div>

            </fieldset>
          </form>
        </div>
      </div>
    );
  }

  handleAdminChange = (userValue: Option<boolean>) => {
    const newValue = userValue ? userValue.value : undefined;
    this.setState({ filter: { ...this.state.filter, isAdmin: newValue } });
  }

  handleCheckbox = (event: any) => {
    this.setState({ filter: { ...this.state.filter, allScopes: !this.state.filter.allScopes } });
  }

  handleTextInputChange = (event: React.ChangeEvent<any>) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const newValue = {};
    newValue[name] = value;

    this.setState({ filter: { ...this.state.filter, ...newValue } });
  }

  handleScopeChange = (opts: Option[]) => {
    let selectedScopes: string[] = [];
    opts.forEach( s => {
      selectedScopes =  selectedScopes.concat(s.value as string);
    });
    this.setState({ filter: { ...this.state.filter, scopes: selectedScopes } });
  }

  handleApply = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (JSON.stringify(this.props.filter) !== JSON.stringify(this.state.filter)) {
      this.props.onFilterApply(this.state.filter);
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/userManagement/userFilter.tsx